import { Button, Divider, FormControl, FormLabel, Heading, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Switch, toVarReference, useDisclosure, useToast } from "@chakra-ui/react";
import React, { useEffect } from "react";
import axios from "axios";
import { useState } from "react";
import { ChatState } from "../../../Context/ChatProvider";


function Payement_crud({ setFetchAgain, Id, level }) {

    const { isOpen, onOpen, onClose } = useDisclosure();
    const toast = useToast();

    const [studentId, setStudentId] = useState(Id);
    const [dateStart, setDateStart] = useState('');
    const [dateEnd, setDateEnd] = useState();
    const [totaleMonth, setTotaleMonth] = useState();
    const [amount, setAmount] = useState();
    const [reduction, setReduction] = useState(0);
    const [pricePaid, setPricePaid] = useState();
    const [restPayement, setRestPayement] = useState(0);
    const [picLoading, setPicLoading] = useState(false);

    const { user } = ChatState();



    useEffect(() => {

        if (dateStart) {
            const d = new Date(new Date(dateStart).toLocaleDateString())
            d.setMonth(d.getMonth() + 1)
            setDateEnd(d.toISOString().substring(0, 10))
        }

    }, [dateStart])

    useEffect(() => {

        if (dateStart && dateEnd) {
            setTotaleMonth(monthDiff())
        }

    }, [dateStart, dateEnd])


    useEffect(() => {

        if (dateStart && dateEnd && amount && reduction && pricePaid) {
            const Totale = reduction == 0 ? (amount * totaleMonth) : ((amount * totaleMonth) - ((amount * totaleMonth) * reduction) / 100);
            const rest=(Totale-pricePaid)
            setRestPayement(rest);
        }

    }, [dateStart, dateEnd, amount, reduction, pricePaid])

    const monthDiff = () => {
        const d1 = new Date(dateStart);
        const d2 = new Date(dateEnd);
        return (Math.max(0, (d2.getFullYear() - d1.getFullYear()) * 12 - d1.getMonth() + d2.getMonth()));
    }
    async function getLevelInfo() {
        try {

            if (level !== '') {


                const config = {
                    headers: {
                        Authorization: `Bearer ${user.token}`,
                    },
                    params: { levelName: level }
                };
                const { data } = await axios.get(`/api/level`, config)

                setAmount(data[0].price);

            }

        } catch (error) {
            toast({
                title: "Une erreur s'est produite !",
                description: "Échec du chargement des résultats de recherche",
                status: "error",
                duration: 5000,
                isClosable: true,
                position: "bottom-left",
            });
        }
    }

    const openModal = () => {

        getLevelInfo();
        setStudentId(Id);
        setDateStart('');
        setDateEnd('');
        setReduction(0);
        setPricePaid('');
        setRestPayement(0);

        onOpen()
    }

    async function getRestPayementByStudentId() {
		try {

			const config = {
				headers: {
					Authorization: `Bearer ${user.token}`,
				},
				params: { studentId: studentId,dateEnd:dateEnd }
			};
			const { data } = await axios.get(`/api/payement/restPayement`, config)
			


		} catch (error) {
			toast({
				title: "Une erreur s'est produite !",
				description: "Échec du chargement des résultats de recherche",
				status: "error",
				duration: 5000,
				isClosable: true,
				position: "bottom-left",
			});
		}

	};
    const newPayement = async () => {



        if (!studentId || !dateStart || !dateEnd || !amount || reduction==='' || !pricePaid) {
            toast({
                title: "Veuillez remplir tous les champs",
                status: "warning",
                duration: 5000,
                isClosable: true,
                position: "bottom",
            });
            setPicLoading(false);
            return;
        }

        try {
           
          
            const config = {
                headers: {
                    "Content-type": "application/json",
                    Authorization: `Bearer ${user.token}`,
                },
            };
            await axios.post(
                "/api/payement",
                {
                    studentId,
                    dateStart,
                    dateEnd,
                    amount,
                    reduction,
                    pricePaid,
                    restPayement
                },
                config
            );
            toast({
                title: "Erfolgreich hinzugefügt",
                status: "success",
                duration: 5000,
                isClosable: true,
                position: "bottom",
            });

            getRestPayementByStudentId()
            setFetchAgain(true);
            onClose()
        
        } catch (error) {
            toast({
                title: "Une erreur s'est produite !",
                description: error.response.data.message,
                status: "error",
                duration: 5000,
                isClosable: true,
                position: "bottom",
            });

        }

    };








    return <>
        <Button className="flex items-center align-middle h-20" bg='gray.50' onClick={() => { openModal() }}><i className="fa-solid fa-plus mr-2 text-blue-400"></i> <p>Nouvel paiement</p>  </Button>
        <Modal

            isOpen={isOpen}
            onClose={onClose}
        >
            <ModalOverlay />
            <ModalContent m='auto'>
                <ModalHeader className="bg-gray-50 shadow-md text-black text-xl"><i className="fa-solid fa-layer-group text-2xl mr-1"></i> Payement</ModalHeader>

                <ModalBody pb={6}>


                    <div className="mr-4">

                        {/* <FormControl mt={4}>
                        <p className="text-lg font-bold">{studentId}  {studientName}</p>
                        </FormControl>
                        <FormControl mt={4}>
                       
                              
                        </FormControl> */}
                        <h2 className="text-md font-bold">Période : </h2>
                        <FormControl mt={2}>
                            Du : <input className="w-40 h-10 rounded-md border py-2 px-1 mr-2" type="date" name="dateStart" value={dateStart}
                                onChange={(e) => setDateStart(e.target.value)} />
                            A : <input className="border w-40 h-10 rounded-md py-2 px-1" type="date" name="dateEnd" value={dateEnd}
                                onChange={(e) => setDateEnd(e.target.value)} />
                        </FormControl>
                        <FormControl width={"40"} mt={4}>
                            <Input placeholder='reduction %' id='reduction' value={reduction}
                                onChange={(e) => setReduction(e.target.value)} />
                        </FormControl>



                        <FormControl mt={4}>
                            <Input placeholder='le prix payé' id='pricePaid' value={pricePaid}
                                onChange={(e) => setPricePaid(e.target.value)} />
                        </FormControl>

                        <FormControl mt={4}>
                            {dateStart && dateEnd ?
                                <p className="text-base mt-1 drop-shadow-md font-bold border p-3 bg-gray-50">Totale : {amount}DH/m x {totaleMonth} mois {reduction > 0 ? ' - ' + reduction + ' %' : ""} =  {reduction == 0 ? (amount * totaleMonth) : ((amount * totaleMonth) - ((amount * totaleMonth) * reduction) / 100)} DH</p> : ""}
                            <p className="text-sm mt-1 ml-2  drop-shadow-md font-bold">*Tarif Nivaux {level}  est {amount} DH </p>
                        </FormControl>





                    </div>


                </ModalBody>

                <ModalFooter>
                    <Button colorScheme='blue' mr={3}
                        onClick={newPayement}
                        isLoading={picLoading}>
                        Enregistrer
                    </Button>
                    <Button onClick={onClose}>Annuler</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    </>
}

export default Payement_crud